import { atom } from 'jotai';
import type { SetStateAction } from 'react';

export enum PanMode {
  Disabled = 'DISABLED',
  Enabled = 'ENABLED',
  Dragging = 'DRAGGING',
}

export interface GridPanMode {
  panMode: PanMode;
  mouseIsDown: boolean;
  spaceIsDown: boolean;
}

export const defaultGridPanMode: GridPanMode = {
  panMode: PanMode.Disabled,
  mouseIsDown: false,
  spaceIsDown: false,
};

const gridPanModeBaseAtom = atom<GridPanMode>(defaultGridPanMode);

export const gridPanModeAtom = atom(
  (get) => get(gridPanModeBaseAtom),
  (get, set, update: SetStateAction<GridPanMode>) => {
    const prev = get(gridPanModeBaseAtom);
    const newVal = typeof update === 'function' ? update(prev) : update;

    let computedPanMode: PanMode;

    if (newVal.spaceIsDown && newVal.mouseIsDown) {
      computedPanMode = PanMode.Dragging;
    } else if (newVal.spaceIsDown) {
      computedPanMode = PanMode.Enabled;
    } else if (newVal.panMode !== PanMode.Dragging || !newVal.mouseIsDown) {
      computedPanMode = PanMode.Disabled;
    } else {
      computedPanMode = newVal.panMode;
    }

    set(gridPanModeBaseAtom, { ...newVal, panMode: computedPanMode });
  }
);

export const gridPanMode = atom((get) => get(gridPanModeAtom).panMode);
